export default __webpack_public_path__ + "static/media/img-0804-greece-premium-face.9eb23e64.png";